var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-banner img-cover",style:(_vm.aStyle)},[_c('div',{staticClass:"swiper-module",style:({
      top: `${_vm.$unit(_vm.imageValue.top)}`
    })},[_c('swiper',{ref:"mcBanner",staticClass:"swiper",attrs:{"options":_vm.modelObj.tranform}},_vm._l((_vm.list),function(pic){return _c('swiper-slide',{key:pic.id},[_c('img',{attrs:{"src":pic.image}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }